import React from "react"
import { DatePicker } from "@material-ui/pickers"
import type { Moment } from "moment"
import { isoStringWithoutZone } from "./helpers/date"

interface IProps {
  input?: {
    name?: string
    onChange?(_: string): void
    onBlur?(_: string): void
    value?: Date | undefined
  }
  meta: { touched; error; warning }
  defaultValue?: Date | string | undefined
  floatingLabelText?: string
  openToYearSelection?: boolean
}

const DatePickerField = ({
  input: { name, onChange: onChangeFromInput, onBlur, value: inputValue },
  meta: { touched, error, warning },
  defaultValue,
  floatingLabelText,
  openToYearSelection,
  ...rest
}: IProps) => {
  const value = inputValue ? new Date(inputValue) : defaultValue || null
  const errorMessage = touched && (error || warning)

  const onChange = (newValue: Moment | null) => {
    onChangeFromInput(newValue ? isoStringWithoutZone(newValue.toDate()) : null)
  }

  return (
    <DatePicker
      {...rest}
      name={name}
      onBlur={() => onBlur(value ? isoStringWithoutZone(value as Date) : null)}
      style={{ width: "100%" }}
      label={floatingLabelText}
      format="DD/MM/YYYY"
      openTo={openToYearSelection ? "year" : undefined}
      error={errorMessage}
      helperText={errorMessage}
      value={value as Date}
      onChange={onChange}
    />
  )
}

export default DatePickerField
